var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "button-click-left", staticStyle: { float: "left" } },
        [
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              attrs: { placeholder: "Chọn đại lý" },
              on: {
                change: function ($event) {
                  return _vm.changeAgentMethod()
                },
              },
              model: {
                value: _vm.dataSearch.idAgent,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idAgent", $$v)
                },
                expression: "dataSearch.idAgent",
              },
            },
            _vm._l(_vm.agentList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { value: item.id, label: item.agentName },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "button-left-class_search",
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "Chọn trường",
              },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.idSchool,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idSchool", $$v)
                },
                expression: "dataSearch.idSchool",
              },
            },
            _vm._l(_vm.schoolList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  value: item.id,
                  label: item.id + " - " + item.schoolName,
                },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              staticStyle: { "margin-right": "5px" },
              attrs: { placeholder: "Kiểu gửi", clearable: "" },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.sendType,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "sendType", $$v)
                },
                expression: "dataSearch.sendType",
              },
            },
            _vm._l(_vm.sendTypeList, function (item) {
              return _c("el-option", {
                key: item.status,
                attrs: { value: item.status, label: item.label },
              })
            }),
            1
          ),
          _c(
            "el-input",
            {
              staticStyle: { width: "300px" },
              attrs: { placeholder: "Nhập tiêu đề tìm kiếm", clearable: "" },
              on: {
                clear: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.title,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "title", $$v)
                },
                expression: "dataSearch.title",
              },
            },
            [
              _c("el-button", {
                attrs: { slot: "append", icon: "el-icon-search" },
                on: {
                  click: function ($event) {
                    return _vm.searchHeaderMethod()
                  },
                },
                slot: "append",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-click row-data" },
        [
          _c(
            "el-button",
            {
              staticClass: "button-over",
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.createNotifyDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v("\n      Tạo thông báo\n    "),
            ]
          ),
          _c(
            "el-dropdown",
            { on: { command: _vm.handleSendNotify } },
            [
              _c(
                "el-button",
                { staticClass: "button-over", attrs: { type: "success" } },
                [
                  _vm._v("\n        Tác vụ\n        "),
                  _c("i", { staticClass: "el-icon-caret-bottom" }),
                ]
              ),
              _c(
                "el-dropdown-menu",
                [
                  _c("el-dropdown-item", [_vm._v("Gửi qua App")]),
                  _c("el-dropdown-item", [_vm._v("Gửi qua Sms")]),
                  _c(
                    "el-dropdown-item",
                    { attrs: { command: "deleteNotifyApp" } },
                    [_vm._v("Xóa thông báo")]
                  ),
                  _c("el-dropdown-item", [_vm._v("Xuất danh sách")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-content row-data" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              attrs: {
                "empty-text": _vm.textTable,
                "element-loading-text": _vm.$tableLoading,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255, 0)",
                data: _vm.responseDataList,
                "highlight-current-row": "",
                "row-style": _vm.tableRowStyle,
                "header-cell-style": _vm.tableHeaderColor,
                border: "",
                "max-height": _vm.$tableMaxHeight,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdDate",
                  width: "140px",
                  label: "Thời gian",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.createdDate)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  width: "170px",
                  label: "Người gửi",
                },
              }),
              _c("el-table-column", {
                attrs: { width: "250px", prop: "sendTitle", label: "Tiêu đề" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "400px",
                  prop: "sendContent",
                  label: "Nội dung",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "100px",
                  prop: "fileNumber",
                  label: "Số File",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: "DS người nhận", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleListReceiver(
                                  scope.$index,
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v("Xem")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  fixed: "right",
                  width: "160px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.$index, scope.row)
                              },
                            },
                          },
                          [_vm._v("Sửa")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.$index, scope.row)
                              },
                            },
                          },
                          [_vm._v("Xóa")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "paging-click row-data" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.pageNumber,
              "page-sizes": _vm.$pageListDefaultNew,
              "page-size": _vm.maxPageItem,
              layout: _vm.$pageLayoutDefault,
              total: _vm.pageTotal,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("CreateAppSendNotify", {
        ref: "CreateAppSendNotify",
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
      _c("UpdateAppSendNotify", {
        ref: "UpdateAppSendNotify",
        attrs: { dialogVisible: _vm.showUpdateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseUpdateMethod()
          },
        },
      }),
      _c("ListReceiver", {
        ref: "ListReceiver",
        attrs: { dialogVisible: _vm.showListReceiver },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseListReceiverMethod()
          },
        },
      }),
      _c("ViewContentNotify", {
        ref: "ViewContentNotify",
        attrs: {
          sendContentNotify: _vm.sendContentNotify,
          dialogVisible: _vm.showContentNotify,
        },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseViewContentMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }